export default "__VITE_ASSET__9ViejCaz__"